import axios from "axios";
import baseURL from "./../api";
class FundsService {

    withdrawFund(data) {
        return axios.post(`${baseURL}/fund/withdraw`, data);
    }

    
    depositFund(data) {
        return axios.post(`${baseURL}/fund/deposit`, data);
    }

    fundHistory(filterData,pageNumber, rowsPage) {
        filterData.userId = '';
        let formattedStartDate = '';
        let formattedEndDate = '';
        let paymentType = '';
        if(filterData.agent_id) {
          filterData.userId = filterData.agent_id
        }
        if(filterData.customer_id) {
          filterData.userId = filterData.customer_id
        }
        if(filterData.from_date) {
          const startDate = filterData.from_date; 
          const parts = startDate.split('-');
          formattedStartDate = `${parts[2]}-${parts[1]}-${parts[0]}`;
        }
        if(filterData.end_date) {
          const startDate = filterData.end_date; 
          const parts = startDate.split('-');
          formattedEndDate = `${parts[2]}-${parts[1]}-${parts[0]}`;
        }
        if(filterData.payment_method) {
          paymentType = filterData.payment_method.toUpperCase();
        }
        
        return axios.get(`${baseURL}/fund/history?fromDate=${formattedStartDate}&toDate=${formattedEndDate}&transferType=${paymentType}&userId=${filterData.userId}&page=${pageNumber}&size=${rowsPage}`);
       // return axios.get(`${baseURL}/fund/history`)
    }

}
export default new FundsService();